export default __webpack_public_path__ + "static/media/burger.84046e78.svg";